<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      :elevation="hover ? 6 : 2"
      class="ma-1"
    >
      <!-- <core-rfq-card-header
        :icon="statusIcon"
        :data="rfqData"
        :menu-items="menuItems"
        @cancel="deleteItem"
      /> -->
      <v-skeleton-loader type="list-item-avatar-two-line" />

      <v-card-text>
        <v-row justify="center">
          <v-col cols="5">
            <v-skeleton-loader type="image" height="40px" />
          </v-col>

          <v-col cols="3" offset="-2">
            <v-skeleton-loader type="image" height="40px" />
          </v-col>
        </v-row>
      </v-card-text>

      <!-- <core-rfq-card-actions
        :rfq="rfqData"
        :expanded="isExpanded"
        :toggleaction="toggleExpanded"
      /> -->
      <v-card-actions>
        <v-skeleton-loader type="text" width="125px" />
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>
export default {

};
</script>
